export default __webpack_public_path__ + "static/media/mascara.ba2878a5.png";